export const GLOBAL_ADMIN_LOCATION = '__GLOBAL__';

/** Storage key for OAuth return path. Set before redirect, read in AuthCallback. */
export const AUTH_RETURN_TO_KEY = 'authReturnTo';

/** Fallback path after login when no valid return path (avoid landing page). */
export const DEFAULT_POST_LOGIN_SLUG = 'oakland';
